import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "src/styles/slick.css";
import "src/styles/slick-theme.css";
import { Link, useLocation } from "react-router-dom";
import Body from "src/components/common/Body";
import styled from "styled-components";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import RejectionReason from "src/components/as/RejectionReason";
import { useReportApproveMutation, useReportApproveRejectMutation, useReportDetailQuery } from "src/api/reportAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import { useAppSelector } from "src/store/actions/action";
import { isEmpty } from "lodash";
import queryString from "query-string";
import asDetail from "./asDetail";
import moment from "moment";
import ImageModal, { RefProps } from "src/components/common/ImageModal";
import VideoBox from "src/components/common/VideoBox";
import ErrorParser from "src/utils/jsonParser";

const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;

function reportDetail() {
  const navigate = useNavigate();
  const { search, state: propsState } = useLocation();
  const queryParser = queryString.parse(search);
  const rnData = queryParser["rn"];

  const as_idx = getPathValue();
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);

  // 초기 변수 선언
  const [state, setState] = useState<any>({
    reportDetailData: [],
    rejectReason: "",
    isRetry: false,
    isComplete: false,
    userType: userInfo.user_type,
    progress: "",
  });

  const { reportDetailData, isRetry, rejectReason, isComplete, userType, progress } = state;

  const [navigateStateData, setNavigateStateData] = useState<any>(propsState);

  const [deleteYn, setDeleteYn] = useState<string>();

  const [esCode, setEsCode] = useState<string>();

  // API 영역
  const reportDetailAPI = useReportDetailQuery(as_idx);
  const [approveRejectUpdate, { isError: approveRejectIsError, isSuccess: approveRejectIsSuccess }] = useReportApproveRejectMutation();
  const [completeUpdate, { isError: completeIsError, isSuccess: completeIsSuccess, error: completeError, status: completeStatus }] = useReportApproveMutation();

  // hook 영역
  useEffect(() => {
    if (reportDetailAPI.isSuccess) {
      setState({
        ...state,
        reportDetailData: reportDetailAPI.data,
        progress: reportDetailAPI.data.progress,
        rejectReason: reportDetailAPI.data.reject_reason,
      });
    }
  }, [reportDetailAPI]);

  useEffect(() => {
    if (!isEmpty(navigateStateData)) {
      setDeleteYn(navigateStateData.deleteYn);
      setEsCode(navigateStateData.esCode);
    }
  }, [navigateStateData]);

  //  API 호출 (state 값 변경시)
  useEffect(() => {
    if (isComplete) {
      if (esCode === "EAC_100") {
        completeUpdate(as_idx);
      } else {
        alert("견적서가 완료처리 되지 않았습니다.");
        setState({
          ...state,
          isComplete: false,
        });
      }
    }
  }, [state]);

  // 보완요청 업데이트 완료시
  useEffect(() => {
    if (approveRejectIsSuccess) {
      navigate("/as-detail/" + as_idx);
    }
  }, [approveRejectIsSuccess]);

  // 완료보고 승인 성공시
  useEffect(() => {
    if (completeIsSuccess) {
      navigate("/as-detail/" + as_idx);
    }
  }, [completeIsSuccess]);

  useEffect(() => {
    if (completeIsError) {
      const message = ErrorParser(completeError);
      alert(message);
    }
  }, [completeIsError]);

  const onChange = (e: any) => {
    const { value, id } = e.target;
    setState({
      ...state,
      [id]: value,
    });
  };

  // 퍼블리싱 영역
  const imageModalRef = React.useRef<RefProps>(null);
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const slider1 = React.useRef(null);
  const slider2 = React.useRef(null);

  useEffect(() => {
    if (slider1.current !== null && slider2.current !== null) {
      setNav1(slider1.current);
      setNav2(slider2.current);
    }
  }, [reportDetailData]);

  const settingsNav1 = {
    ref: slider1,
    asNavFor: nav2,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const settingsNav2 = {
    ref: slider2,
    asNavFor: nav1,
    useTransform: false,
    dots: true,
    infinite: false,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    cssEase: "ease-out",
  };

  const openImageSlider = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (imageModalRef.current) imageModalRef.current.modalOpen();
  };

  const backClick = () => {
    if (!isEmpty(rnData)) {
      navigate("/as-detail/" + as_idx);
    } else {
      navigate(-1);
    }
  };

  const reCompleteBtn = () => {
    if (isEmpty(rejectReason)) {
      alert("보완요청 사유를 작성해 주세요");
      return;
    }
    const params = {
      as_idx: as_idx,
      reject_reason: rejectReason,
    };
    approveRejectUpdate(params);
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => backClick()}>
            완료보고
          </Button>
        </div>
      </header>

      <Body type="detail">
        <FlexWrap>
          {userInfo.user_type === "M" && rejectReason !== null && progress !== "ASC_100" && (
            <RejectionReason value={rejectReason} readonly title="보완요청 사유" />
          )}
          <Box pd="40px 0">
            <TitleBox>
              <p className="title">{reportDetailData ? reportDetailData.company_name : ""}</p>
              <p className="date">{reportDetailData ? moment(reportDetailData.completion_date).format("YYYY.MM.DD HH:mm") : ""}</p>
            </TitleBox>

            {!isEmpty(reportDetailData) && (
              <>
                {reportDetailData.images.length > 0 ? (
                  <ImgSlide>
                    <Slider {...settingsNav1}>
                      {reportDetailData.images.map((v: any, k: number) => {
                        return (
                          <div onClick={openImageSlider} key={k}>
                            <div className="img-box detail-slide" key={k}>
                              {v.ext === "mp4" || v.ext === "mov" ? (
                                <VideoBox
                                  controls
                                  vimeoId={v.img_url}
                                  // src={imageServerIp + v.img_url}
                                />
                              ) : (
                                <img src={imageServerIp + v.img_url} alt={v.img_name} />
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </ImgSlide>
                ) : (
                  ""
                )}
              </>
            )}
            <ContentBox>{reportDetailData ? reportDetailData.completion_contents : ""}</ContentBox>
          </Box>

          {deleteYn !== "Y" && (
            <>
              {userType === "E" && progress !== "ASC_100" && progress !== "ASC_70" ? (
                <BottomFlex>
                  {!isRetry && (
                    <ButtonBox>
                      <Button variant="outlined" br="round" color="secondary" onClick={() => setState({ ...state, isRetry: isRetry ? false : true })}>
                        보완 요청
                      </Button>
                      <Button variant="contained" br="round" onClick={() => setState({ ...state, isComplete: true })}>
                        확인
                      </Button>
                    </ButtonBox>
                  )}

                  {/* <ButtonBox>
              <Button variant="contained" br="round">
                완료보고 수정
              </Button>
            </ButtonBox> */}

                  {isRetry ? (
                    <>
                      <RejectionReason
                        onChange={(e) => onChange(e)}
                        id="rejectReason"
                        title="보완요청 사유"
                        placeholder="보완요청 사유입니다."
                        // value={rejectReason}
                      />
                      <ButtonBox>
                        <Button variant="contained" br="round" onClick={() => reCompleteBtn()}>
                          완료보고 재요청
                        </Button>
                      </ButtonBox>
                    </>
                  ) : (
                    ""
                  )}
                </BottomFlex>
              ) : (
                <>
                  {userType === "M" && progress === "ASC_70" ? (
                    <BottomFlex>
                      <ButtonBox>
                        <Button variant="contained" br="round" onClick={() => navigate("/report-register/" + as_idx)}>
                          완료보고 수정
                        </Button>
                      </ButtonBox>
                    </BottomFlex>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          )}
        </FlexWrap>
      </Body>

      <ImageModal ref={imageModalRef}>
        <ModalImgSlide>
          <StyledSlider {...settingsNav2}>
            {reportDetailAPI.isSuccess &&
              reportDetailAPI.data.images.length > 0 &&
              reportDetailAPI.data.images.map((v: any, k: number) => {
                return (
                  <div className="img-box" key={k}>
                    {v.ext === "mp4" || v.ext === "mov" ? (
                      <VideoBox
                        controls
                        playAllow
                        vimeoId={v.img_url}
                        // src={imageServerIp + v.img_url}
                      />
                    ) : (
                      <img src={imageServerIp + v.img_url} alt={v.img_name} />
                    )}
                  </div>
                );
              })}
          </StyledSlider>
        </ModalImgSlide>
      </ImageModal>
    </>
  );
}

const FlexWrap = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "stretch")}
  height: auto;
  min-height: 100%;
  /* > div:last-child {
    flex: 1 0 auto;
  } */
`;

const TitleBox = styled.div`
  padding: 0 45px;
  margin-bottom: 50px;
  .title {
    font-weight: 700;
    font-size: 18px;
  }
  .date {
    margin-top: 10px;
    color: #818181;
    font-size: 14px;
    font-family: "Poppins";
    font-weight: 400;
  }
`;

const ImgSlide = styled.div`
  overflow: hidden;
  height: auto;
  background-color: #fff;
`;

const ContentBox = styled.div`
  padding: 20px 45px;
  color: #001827;
  font-size: 16px;
  line-height: 24px;
`;

const BottomFlex = styled.div`
  padding: 55px 45px;
  border-top: 2px dashed #aaa;
  background-color: ${({ theme }) => theme.color.bgPrimary};
  > dl {
    padding: 0 0 40px;
    textarea {
      background-color: #fff;
    }
  }
`;

const ButtonBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()}
  > button {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const ModalImgSlide = styled.div`
  height: 100%;
  background: #ccc;
`;

const StyledSlider = styled(Slider)`
  .slick-track {
    height: 100%;
  }
  .slick-slide {
    height: 100%;
    ${({ theme }) => theme.flexBox.flexMixin("column", "center", "center")}
    > div {
      height: auto;
      overflow-y: scroll;
    }
    .img-box {
      padding-top: 0;
      > img {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
    }
  }
  .slick-list {
    background: rgba(0, 0, 0, 0.5);
  }
`;

export default reportDetail;
